import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    StyleSheet,
} from 'react-native';

import {
    JDJumping,
} from '@jdreact/jdreact-core-lib';

import { mta, innerWidth, pt, is_web } from '../../common/utils';

import Swiper from 'swiper';

require('./reset.css');
require('./swiper.min.css');


class WebSwiper extends PureComponent {

    render() {
        const { bannerArr } = this.props;

        return (
            <View style={st.container}>

                <div className='swiper-container'>

                    <div className='swiper-wrapper' ref='wrapper'>
                        {bannerArr.map((val, key) => {
                            return (
                                <div className='swiper-slide' data-index={key} key={key}>
                                    <img src={val.picUrl} className='not_tar' />
                                </div>
                            )
                        })}
                    </div>

                    <div className='swiper-pagination' ref='point'></div>
                </div>

            </View>
        );
    }

    componentDidUpdate() {
        if (this.props.bannerArr.length > 1 && !this.swiper) {

            this.swiper = new Swiper('.swiper-container', {
                loop: true,
                autoplay: {
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            });

            this.refs.wrapper.addEventListener('click', (event) => {
                let index = event.target.getAttribute('data-index');
                this.jump(index - 0);
            });

        }
    }

    jump(index) {
        let { bannerArr } = this.props;
        let url = bannerArr[index].linkUrl;
        let title = bannerArr[index].title;
        let routeType = bannerArr[index].routeType;
        let routeParam = bannerArr[index].routeParam;
        mta('HomeBanner', 'Home', title);

        if (!!routeType && !!routeParam) {
            if (routeType === 'movieDetail') {
                this.context.router.toMovieDetail({ movieId: routeParam });
            }

            if (routeType === 'movieSchedule') {
                this.context.router.toMovieSchedule({ movieId: routeParam });
            }
            return;
        }

        JDJumping.jumpToWeb(url).catch(err => tip(err));
    }

};

const st = StyleSheet.create({
    container: {
        position: 'relative',
        width: innerWidth,
        height: pt(228),
        backgroundColor: '#fff',
        zIndex: 0,
        marginTop: pt(-36)
    }
});

WebSwiper.contextTypes = {
    router: PropTypes.object
};

export default WebSwiper;